import { OWNER_PHONE } from "@/components/WhatsAppFab";

/**
 * Builds the WhatsApp order message that a customer forwards to the owner
 * after checkout confirmation. Returns a wa.me URL.
 */
export function buildOrderWhatsAppUrl(order, formatMAD) {
    const lines = [
        "🛍️ Nouvelle commande Make Rizk",
        "",
        `N° : ${order.order_number}`,
        "",
        "Client :",
        `Nom : ${order.customer.name}`,
        `Téléphone : ${order.customer.phone}`,
        `Adresse : ${order.customer.address}`,
        `Ville : ${order.customer.city}`,
    ];
    if (order.customer.notes) lines.push(`Note : ${order.customer.notes}`);
    lines.push("");
    lines.push("Articles :");
    order.items.forEach((it) => {
        const size = it.size ? ` · Taille ${it.size}` : "";
        lines.push(`- ${it.quantity}× ${it.name}${size} — ${formatMAD(it.price * it.quantity)}`);
    });
    lines.push("");
    lines.push(`Sous-total : ${formatMAD(order.subtotal)}`);
    if (order.discount > 0) {
        const promo = order.promo_code ? ` (${order.promo_code})` : "";
        lines.push(`Remise${promo} : -${formatMAD(order.discount)}`);
    }
    lines.push(`Livraison : ${formatMAD(order.shipping_fee)}`);
    lines.push(`Total à encaisser (COD) : ${formatMAD(order.total)}`);
    return `https://wa.me/${OWNER_PHONE}?text=${encodeURIComponent(lines.join("\n"))}`;
}
